import React, {useState} from "react";
import {ASSET_MEMO_LINKED_HEADER} from "../../../../components/table/header/Headers";
import {getAssetMemos} from "../../../../api/asset/AssetService";
import useRequestData from "../../../../hooks/useRequestData";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Search from "../../../../components/search/Search";
import {CodeSpecNum} from "../../../../constant/CodeSpecNum";
import {extractObject} from "../../../../components/commonmethod/CommonMethod";
import DetailLinkedListView from "../../../../components/detailLayout/DetailLinkedListView";
import AssetMemoDetailModal from "./subPages/list/AssetMemoDetailModal";

function AssetMenoTab({id}) {
    const [selectedMemo, setSelectedMemo] = useState(null);

    const {newData, pageInfo, dataHook} = useRequestData((conditions, pageable) => {
        const finalConditions = {
            ...conditions,
            entityId: id,
        };
        return getAssetMemos(finalConditions, pageable);
    }, {});

    const {handleSearch, handlePageSizeChange, saveConditions, handleGridPageChange} = dataHook;

    const handleRowClick = (row) => {
        setSelectedMemo(row);
    };

    return (
        <>
            <DetailLinkedListView
                headerDefinition={ASSET_MEMO_LINKED_HEADER}
                settingKey="asset_memo"
                newData={newData}
                onPageChange={handleGridPageChange}
                onRowClick={handleRowClick}
            >
                <Search
                    searchConditions={saveConditions}
                    handleSearch={handleSearch}
                    handlePageSizeChange={handlePageSizeChange}
                    pageInfo={pageInfo}
                    size
                    detail
                    searchBar={{placeHolder: "제목"}}
                >
                    <SearchSection>
                        <Selector
                            showLabel
                            onChange={(value) => searchListener(handleSearch, "code", extractObject(saveConditions), value)}
                            data={saveConditions.code}
                            recursive
                            parentKey={CodeSpecNum.AssetMemo}
                            entity={"code"}
                            title={"자산기록 코드"}
                        />
                    </SearchSection>
                </Search>
            </DetailLinkedListView>

            <AssetMemoDetailModal
                open={Boolean(selectedMemo)}
                item={selectedMemo}
                onClose={() => setSelectedMemo(null)}
            />
        </>
    );
}

export default AssetMenoTab;
